import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 13.54V20h12v-7H11.925l3.887 3.11a.5.5 0 1 1-.624.78L11 13.54zm-1 0l-4.188 3.35a.5.5 0 1 1-.624-.78L9.075 13H1v7h9v-6.46zm1-3.366c.885-1.966 1.706-3.194 2.463-3.686A3.43 3.43 0 0 1 17.529 12H23V4H11v6.174zm-1-.01V4H1v8h2.475a3.431 3.431 0 0 1 4.067-5.512c.755.49 1.574 1.716 2.458 3.676zM1.5 3h21c.9 0 1.5.6 1.5 1.5v15c0 .9-.6 1.5-1.5 1.5h-21C.6 21 0 20.4 0 19.5v-15C0 3.6.6 3 1.5 3zm5.497 4.327a2.43 2.43 0 1 0-2.647 4.077c.704.458 2.515.67 5.325.56-1.042-2.611-1.973-4.18-2.678-4.637zm9.658 4.077a2.43 2.43 0 1 0-2.647-4.077c-.705.458-1.636 2.026-2.678 4.637 2.81.11 4.62-.102 5.325-.56z"
});

var SvgGiftcard = function SvgGiftcard(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgGiftcard;